export default function() {
  return {
    tags: [],
    tagsSimplified: [],
    pendingTags: [],
  };
}
